import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import './ActivityActiveCell.scss';

const ActivityActiveCell = ({
  value,
  row: { index, original },
  column: { id },
  updateDataFieldFromCell,
  updateItem
}) => {
  const handleToggle = useCallback(async () => {
    const newValue = !value;
    const res = await updateItem(original._id, { active: newValue });

    if (res) {
      updateDataFieldFromCell(index, id, newValue);
    }
  }, [value, index, id, original._id]);

  return (
    <div className="activity-active-cell" onClick={handleToggle}>
      <div className={`active-toggle ${value ? 'is-active' : 'is-inactive'}`}>
        <div className="toggle-slider" />
      </div>
      <span className={value ? 'active-label' : 'inactive-label'}>
        {value ? 'Active' : 'Inactive'}
      </span>
    </div>
  );
};

ActivityActiveCell.propTypes = {
  value: PropTypes.bool.isRequired,
  row: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  updateDataFieldFromCell: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired
};

export default ActivityActiveCell;
